import { LoaderFunctionArgs, redirect } from "react-router";

export default async function feeScheduleLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/fee-schedules/templates");
  return routeParams;
}
